import { Box, Container, Stack } from "@mui/material";
import { NewAnalysisForm } from "Components/Analyses/NewAnalysis/NewAnalysisForm";
import { NewAnalysisHeader } from "Components/Analyses/NewAnalysis/NewAnalysisHeader";
import { NewAnalysisSelectedClient } from "Components/Analyses/NewAnalysis/NewAnalysisSelectedClient";
import { AuthenticatedLayout } from "Components/_Shared/Layouts/AuthenticatedLayout";
import { StyledBackground } from "Components/_Shared/Layouts/StyledBackground";
import type { SearchedClient, SearchedLocalClient } from "Infrastructure/ApiZfp/Schema";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useState } from "react";

export const NewAnalysisPage: React.FunctionComponent = () => {
  const { t } = useResource();
  const [selectedClient, setSelectedClient] = useState<SearchedClient | SearchedLocalClient | null>(null);

  return (
    <AuthenticatedLayout title={t(Resources.NewAnalysis.Title)} appBarVariant="dark" container={false}>
      <Stack width="100%">
        <StyledBackground>
          <Box pt={Spacing.XL}>
            <NewAnalysisHeader onClientSelect={setSelectedClient} />
          </Box>
        </StyledBackground>
        <Container maxWidth="sm" disableGutters>
          <Box mt={Spacing.XXL}>
            {selectedClient ? (
              <NewAnalysisSelectedClient client={selectedClient} onCancel={() => setSelectedClient(null)} />
            ) : (
              <NewAnalysisForm onCancel={() => setSelectedClient(null)} onClientSelect={setSelectedClient} />
            )}
          </Box>
        </Container>
      </Stack>
    </AuthenticatedLayout>
  );
};
